export const loanColumns = [
  { field: "loanAccountNumber", headerName: "Loan Acc No", flex: 1 },

  {
    field: "userName",
    headerName: "Customer Name",
    flex: 1,
    valueGetter: (_, row) => row?.userId?.name || "N/A",
  },

  {
    field: "accountNumber",
    headerName: "A/C No",
    flex: 1,
    valueGetter: (_, row) => row?.userId?.accountNumber || "N/A",
  },

  { field: "principalAmount", headerName: "Amount", flex: 1 },
  { field: "tenureMonths", headerName: "Tenure", flex: 1 },
  { field: "status", headerName: "Status", flex: 1 },
];

export const fdColumns = [
  { field: "fdNumber", headerName: "FD Number", flex: 1 },

  {
    field: "userName",
    headerName: "Customer Name",
    flex: 1,
    valueGetter: (_, row) => row?.userId?.name || "N/A",
  },

  {
    field: "accountNumber",
    headerName: "A/C No",
    flex: 1,
    valueGetter: (_, row) => row?.userId?.accountNumber || "N/A",
  },

  { field: "principalAmount", headerName: "Amount", flex: 1 },
  { field: "interestRate", headerName: "Interest %", flex: 1 },
  { field: "maturityAmount", headerName: "Maturity", flex: 1 },
];

export const insuranceColumns = [
  { field: "policyNumber", headerName: "Policy No", flex: 1 },

  {
    field: "userName",
    headerName: "Customer Name",
    flex: 1,
    valueGetter: (_, row) => row?.userId?.name || "N/A",
  },

  {
    field: "accountNumber",
    headerName: "A/C No",
    flex: 1,
    valueGetter: (_, row) => row?.userId?.accountNumber || "N/A",
  },

  { field: "provider", headerName: "Provider", flex: 1 },
  { field: "type", headerName: "Type", flex: 1 },
  { field: "coverageAmount", headerName: "Coverage", flex: 1 },
];
